import api from 'config/api';

export default {
  getUserInformation: () => api.get('admin_api/v1/admin_users')
};
